<section class="mat-typography mat-body component-container">

  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="inputs">
      <!-- Application Submission Number -->
      <mat-form-field appearance="outline" class="leftInput">
        <mat-label>Application Submission Number</mat-label>
        <input matInput formControlName="applicationTrackingNumber" (change)="onChange()" required />
        @if (form.controls.applicationTrackingNumber.errors?.required) {
          <mat-error>Required</mat-error>
        }
      </mat-form-field>

      <!-- Last Name -->
      <mat-form-field appearance="outline" class="rightInput">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastName" (change)="onChange()" required />
        @if (form.controls.lastName.errors?.required) {
          <mat-error>Required</mat-error>
        }
      </mat-form-field>
    </div>

    @if (noDataFoundContent) {
      <div>
        <span class=errortext>We are unable to locate an application. Please verify the information and try again. If
          you need
          additional assistance, please see the <a href="/contact-us.html" target="_blank">Contact Us</a>
          section.
        </span>
      </div>
    }

    @if (!serviceCalled && (form.value.applicationTrackingNumber && form.value.lastName)) {
      <div class="submit-container">
        <button mat-raised-button color="primary" type="submit" class="sButton">Submit</button>
      </div>
    }
  </form>

  @if (statusDataRetrieved && appStatusResponseRetrieved) {
    <!-- <div class="response-item mat-elevation-z2">
    <h3>{{appStatusResponseRetrieved.applicationTrackingId}}</h3> -->
    <!-- <div class="response-item-row">
    <div class="label">Product Type:</div>
    <div>{{appStatusResponseRetrieved.productType}}</div>
  </div> -->
  <!-- <div class="response-item-row">
  <div class="label">Product Description:</div>
  <div>{{appStatusResponseRetrieved.productDescription}}</div>
</div>
<div class="response-item-row">
  <div class="label">Submitted Date:</div>
  <div>{{appStatusResponseRetrieved.creationDate}}</div>
</div>
<div class="response-item-row">
  <div class="label">Downstream Application Status:</div>
  <div>{{appStatusResponseRetrieved.downstreamTrackingStatus}}</div>
</div>
<div class="response-item-row">
  <div class="label">Portal Application Status:</div>
  <div>{{appStatusResponseRetrieved.portalApplicationStatus}}</div>
</div>
</div> -->
<div class="info-card mat-elevation-z2">
  <div class="header">
    <div class="sec1">
      <div class="label">Application Submission Number:</div>
      <div class="value">{{appStatusResponseRetrieved.applicationTrackingId}}</div>
    </div>
    <div class="sec2">
      <div class="label">Plan:</div>
      <div class="value">{{appStatusResponseRetrieved.productDescription}}</div>
    </div>
  </div>
  <div class="body flex-between">
    <div class="col1">
      <div class="entity grid-40-60">
        <div class="body-label">Applicant Name</div>
        <span> : </span>
        <div class="body-value">{{appStatusResponseRetrieved.applicantFirstName}}
        {{appStatusResponseRetrieved.applicantLastName}}</div>
      </div>
    </div>
    <div class="col2">
      <div class="entity divider">
        <div class="body-label">Application Submission Date</div>
        <span> : </span>
        <div class="body-value">{{appStatusResponseRetrieved.applicationLastModified | date:'MM/dd/yyyy'}}</div>
      </div>
      <div class="entity divider">
        <div class="body-label">Billing Information</div>
        <span> : </span>
        <div class="body-value">{{appStatusResponseRetrieved.billingFrequency}}</div>
      </div>
    </div>
    <div class="col3">
      <div class="entity divider">
        <div class="body-label">Requested Effective Date</div>
        <span> : </span>
        <div class="body-value">{{appStatusResponseRetrieved.effectiveDate}}</div>
      </div>
      <div class="entity divider">
        <div class="body-label">Application Status</div>
        <span> : </span>
        <div class="body-value">{{appStatusResponseRetrieved.combinedStatus}}</div>
      </div>
    </div>
  </div>
  <div class="footer">
    <div class="link">
      <a href="/contact-us.html" target="_blank">Contact Us</a>
    </div>
  </div>
</div>
}

<!-- <ng-container *ngIf="noDataFoundContent">
<div>
  <h2><span>We are unable to locate an application. Please verify the information and try again. If you need
    additional assistance, please see the <a href="/contact-us.html" target="_blank">Contact Us</a>
  section.</span></h2>
</div>
</ng-container> -->
</section>
